import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const marqueeText = 'Gemenskap \u2022 Gl\u00e4dje \u2022 Hopp \u2022 Tillsammans g\u00f6r vi skillnad \u2022 ';

const sponsors = [
  { src: '/hela-manniskan.png', alt: 'Hela Människan Storstockholm' },
  { src: '/sponsor-1.png', alt: 'ICA' },
  { src: '/sponsor-2.png', alt: 'Matmissionen' },
  { src: '/sponsor-3.png', alt: 'Pressbyran' },
  { src: '/solace.png', alt: 'Solace' },
];

function SponsorCarousel() {
  const trackRef = useRef(null);

  const scrollBy = (dir) => {
    if (!trackRef.current) return;
    trackRef.current.scrollBy({ left: dir * 200, behavior: 'smooth' });
  };

  return (
    <div className="sponsors-carousel">
      <button className="sponsor-arrow" onClick={() => scrollBy(-1)} aria-label="Föregående">&#8249;</button>
      <div className="sponsors-track-scroll" ref={trackRef}>
        {[...sponsors, ...sponsors].map((s, i) => (
          <div className="sponsor-item" key={i}>
            <img src={s.src} alt={s.alt} className="sponsor-logo" />
          </div>
        ))}
      </div>
      <button className="sponsor-arrow" onClick={() => scrollBy(1)} aria-label="Nästa">&#8250;</button>
    </div>
  );
}

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Hero - split layout */}
      <section className="hero-section">
        <div className="hero-inner">
          <div className="hero-content">
            <span className="hero-tag">V&aring;rt n&auml;sta event</span>
            <h1 className="hero-title">Vi skapar gemenskap f&ouml;r alla som beh&ouml;ver det.</h1>
            <p className="hero-subtitle">
              Genom v&aring;ra event sprider vi gl&auml;dje, hopp och v&auml;rme. Tillsammans g&ouml;r vi skillnad - en h&ouml;gtid i taget.
            </p>
            <div className="hero-buttons">
              <Link to="/bidra" className="btn btn-primary">Bidra Nu</Link>
              <Link to="/mission" className="btn btn-secondary">L&auml;s Mer</Link>
              <Link to="/anmalan" className="btn btn-secondary">Anm&auml;l dig</Link>
            </div>
          </div>
          <div className="hero-visual">
            <img
              src="/midsommar-tillsammans.png"
              alt="Midsommar Tillsammans poster"
              className="hero-poster"
            />
          </div>
        </div>
      </section>

      {/* Marquee */}
      <div className="marquee-banner">
        <div className="marquee-track">
          {[...Array(10)].map((_, i) => (
            <span key={i}>{marqueeText}</span>
          ))}
        </div>
      </div>

      {/* What we do */}
      <section className="what-we-do">
        <div className="container">
          <div className="wwd-inner">
            <span className="section-tag">Vad vi g&ouml;r</span>
            <h2>St&ouml;d som g&ouml;r skillnad.</h2>
            <p className="wwd-intro">Vi skapar event d&auml;r gemenskap, v&auml;rme och gl&auml;dje st&aring;r i centrum.</p>
            <ul className="wwd-list">
              <li>
                <strong>Mat &amp; gemenskap</strong>
                <span>Gratis mat och fika f&ouml;r alla. Vi samlas runt bordet och delar stunden tillsammans.</span>
              </li>
              <li>
                <strong>G&aring;vor till alla</strong>
                <span>Barn och vuxna f&aring;r g&aring;vor. Ingen ska beh&ouml;va k&auml;nna sig utanf&ouml;r.</span>
              </li>
              <li>
                <strong>Musik &amp; underh&aring;llning</strong>
                <span>Livemusik och aktiviteter som skapar minnen f&ouml;r hela familjen.</span>
              </li>
              <li>
                <strong>Alla &auml;r v&auml;lkomna</strong>
                <span>En trygg milj&ouml; oavsett bakgrund, &aring;lder eller livssituation.</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <div className="cta-banner">
        <div className="cta-banner-content">
          <h2>Vill du g&ouml;ra skillnad?</h2>
          <p>Tillsammans kan vi sprida gl&auml;dje till fler. Bidra ekonomiskt, donera varor eller sprid ordet.</p>
          <div>
            <Link to="/bidra" className="btn-cta-primary">Bidra Nu</Link>
            <Link to="/anmalan" className="btn-cta-secondary">Anm&auml;l dig</Link>
          </div>
        </div>
      </div>

      {/* Main Sponsor */}
      <section className="main-sponsor-section">
        <div className="container">
          <span className="section-tag" style={{ display: 'block', textAlign: 'center' }}>Samarbete</span>
          <h2 className="main-sponsor-title">V&aring;r Huvudsponsor</h2>
          <p className="main-sponsor-intro">
            Hela M&auml;nniskan Storstockholm st&ouml;ttar v&aring;ra event och g&ouml;r det m&ouml;jligt f&ouml;r oss att n&aring; ut till fler.
          </p>

          <div className="main-sponsor-quote-card">
            <div className="quote-header">
              <span className="quote-icon">&#10077;</span>
              <h3>Ett par ord fr&aring;n Hela M&auml;nniskan Storstockholm</h3>
            </div>
            <div className="quote-content">
              <h4>Vi m&ouml;jligg&ouml;r gemenskap</h4>
              <p>
                Eventet genomf&ouml;rs med ekonomiskt st&ouml;d fr&aring;n Hela M&auml;nniskan Storstockholm. Som samarbetspartner m&ouml;jligg&ouml;r vi g&aring;vor, gemenskap och en varm h&ouml;gtid f&ouml;r barn och familjer i utsatthet.
              </p>
              <p>
                Hela M&auml;nniskan Storstockholm &auml;r en id&eacute;buren organisation som vilar p&aring; alla m&auml;nniskors lika v&auml;rde. Vi finns f&ouml;r m&auml;nniskor som lever i utsatthet, ensamhet eller socialt utanf&ouml;rskap.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sponsors Carousel */}
      <section className="sponsors-section">
        <div className="container">
          <span className="section-tag" style={{ display: 'block', textAlign: 'center' }}>Partners</span>
          <h2 className="sponsors-title">V&aring;ra Sponsorer</h2>
          <p className="sponsors-subtitle">Tack till alla som g&ouml;r v&aring;ra event m&ouml;jliga</p>

          <SponsorCarousel />
        </div>
      </section>
    </>
  );
}

export default Home;
